export default function triggerCustomGaEvent(eventName, eventBody) {
	let gaEvent = new CustomEvent(eventName, { detail: eventBody })
	dispatchEvent(gaEvent)

	let dataLayer = window.dataLayer || []

	dataLayer.push({
		event: eventName,
		details: eventBody
	})
}


// WEBPACK FOOTER //
// ./src/utilities/analytics/triggerCustomGaEvent.js